import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../contexts/AuthContext';
import useDocs from '../../hooks/useDocs';

export default function AppUserMenu() {
  const { currentUser, logout } = useAuth();
  const { docs } = useDocs('profiles');
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const username = docs?.username;
  const profileName = docs?.name?.trim();
  const firstName =
    profileName?.split(/\s+/)[0] ||
    username ||
    currentUser?.displayName?.trim()?.split(/\s+/)[0] ||
    (currentUser?.email ? currentUser.email.split('@')[0] : '');
  const label = firstName ? `Hi, ${firstName}` : 'Hi';

  const close = useCallback(() => setOpen(false), []);

  useEffect(() => {
    if (!open) return undefined;
    const onDocMouseDown = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        close();
      }
    };
    const onKey = (e) => {
      if (e.key === 'Escape') close();
    };
    document.addEventListener('mousedown', onDocMouseDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocMouseDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open, close]);

  const handleLogout = async () => {
    close();
    try {
      await logout();
      history.push('/login');
    } catch {
      // ignore; Auth may surface elsewhere
    }
  };

  if (!currentUser) return null;

  return (
    <div className="app-user-menu" ref={wrapRef}>
      <button
        type="button"
        className="app-user-menu-trigger"
        aria-expanded={open}
        aria-haspopup="true"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="app-user-menu-label">{label}</span>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`app-user-menu-chevron${open ? ' app-user-menu-chevron--open' : ''}`}
        />
      </button>
      {open && (
        <div className="app-user-menu-dropdown" role="menu">
          <Link
            to="/user-redirect"
            className="app-user-menu-item"
            role="menuitem"
            onClick={close}
          >
            Profile
          </Link>
          <Link
            to="/update-profile"
            className="app-user-menu-item"
            role="menuitem"
            onClick={close}
          >
            Edit profile
          </Link>
          <Link
            to="/dashboard"
            className="app-user-menu-item"
            role="menuitem"
            onClick={close}
          >
            Account
          </Link>
          <div className="app-user-menu-divider" />
          <button
            type="button"
            className="app-user-menu-item app-user-menu-item--danger"
            role="menuitem"
            onClick={handleLogout}
          >
            Log out
          </button>
        </div>
      )}
    </div>
  );
}
